module.exports = __webpack_public_path__ + "img/poster_universal_R10.267e7b80.jpg";